import {createApp} from "vue";
import {createPinia} from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import "./assets/css/app.css";
import {initializeApp} from "firebase/app";
import {getFirestore, connectFirestoreEmulator} from "firebase/firestore";
import {getAuth} from "firebase/auth";
import {getToken, initializeAppCheck, ReCaptchaEnterpriseProvider} from "firebase/app-check";
// import * as Sentry from "@sentry/vue";
import {userUserStore} from "./stores/user";
import VueVirtualScroller from "vue-virtual-scroller";
//virtual scroll
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import {datadogRum} from "@datadog/browser-rum";

if (import.meta.env.VITE_ENV_NOMBRE == "Produccion") {
  datadogRum.init({
    applicationId: "24830225-caf0-491b-a367-b6d613dd0ff3",
    clientToken: "pubd894ac7a65c61cf89148be298b730a02",
    site: "us5.datadoghq.com",
    service: "fixed-webapp",
    env: "prod",
    version: "2",
    sessionSampleRate: 5,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    sessionReplaySampleRate: 5,
    defaultPrivacyLevel: "mask-user-input"
  });
} /* else if (import.meta.env.VITE_ENV_NOMBRE == "Testing") {
  datadogRum.init({
    applicationId: "e4f7d87f-61f1-4d2d-b554-be405dd2469c",
    clientToken: "pub1ccb2070d6db745a620af1c783fd303a",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.eu",
    service: "fixed",
    env: "testing",
    // Specify a version number to identify the deployed version of your application in Datadog
    version: "v-testing-1",
    sessionSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input"
  });
}  else {
  datadogRum.init({
    applicationId: "e4f7d87f-61f1-4d2d-b554-be405dd2469c",
    clientToken: "pub1ccb2070d6db745a620af1c783fd303a",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.eu",
    service: "fixed",
    env: "dev",
    // Specify a version number to identify the deployed version of your application in Datadog
    version: "v-dev-1",
    sessionSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: "mask-user-input"
  });
}
  */

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
  // measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
if (import.meta.env.VITE_ENV_NOMBRE == "Produccion" || import.meta.env.VITE_ENV_NOMBRE == "Testing") {
  const appCheckKey = import.meta.env.VITE_FIREBASE_APPCHECK_KEY;
  const appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(appCheckKey),
    isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
  });

  getAuth().onAuthStateChanged(async change => {
    if (change == null) {
      const userStore = userUserStore();
      const routeName = router.currentRoute.value.name;

      if (
        routeName != undefined &&
        routeName != "login" &&
        routeName != "logout" &&
        routeName != "registro" &&
        routeName != "analisisDeuda" &&
        routeName != "registroHandy" &&
        routeName != "loginMagicLink" &&
        routeName != "demo" &&
        routeName != "demos" &&
        routeName != "aceptarInvitacion"
      ) {
        userStore.signOut();
      }
    } else {
      await getToken(appCheck, true); // Refresh token
    }
  });
} else {
  getAuth().onAuthStateChanged(async change => {
    if (change == null) {
      const userStore = userUserStore();
      const routeName = router.currentRoute.value.name;

      if (
        routeName != undefined &&
        routeName != "login" &&
        routeName != "logout" &&
        routeName != "registro" &&
        routeName != "analisisDeuda" &&
        routeName != "registroHandy" &&
        routeName != "loginMagicLink" &&
        routeName != "demo" &&
        routeName != "demos" &&
        routeName != "aceptarInvitacion"
      ) {
        userStore.signOut();
      }
    }
  });
}

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(firebaseApp);
if (import.meta.env.VITE_USAR_EMULADOR == "true") {
  console.warn("*** Conectado al emulador de Firestore ***");
  if (import.meta.env.VITE_FIREBASE_LOCAL_NEWTORK == "true") {
    connectFirestoreEmulator(db, import.meta.env.VITE_FIREBASE_IP, 8080);
  } else {
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  }
}

const app = createApp(App);

/* if (import.meta.env.VITE_ENV_NOMBRE == "Produccion") {
  Sentry.init({
    app,
    dsn: "https://b67c3151f00e409a4cdacb56bbcb6fde@o4507075078324224.ingest.us.sentry.io/4507075079897088",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({maskAllText: false})],
    environment: import.meta.env.VITE_ENV_NOMBRE,
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} */

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

// app.config.errorHandler = (err: any, vm: any, info: any) => {
//   console.log("Error capturado:", err);
//   console.log("Vue component:", vm);
//   console.log("Additional info:", info);

//   // if (import.meta.env.VITE_ENV_NOMBRE == "Produccion" && err != null && errorString.toLowerCase().contains("firebase") != null && err.code != null && err.code == "permission-denied") {

//   if (
//     window.location.href.includes("registro") == false &&
//     window.location.href.includes("login") == false &&
//     err == "FirebaseError: [code=permission-denied]: Missing or insufficient permissions."
//   ) {
//     window.location.href = "/logout";
//     console.error("Error de permisos en Firestore - Redirecciono a logout");
//   }
// };

app.use(router).use(VueVirtualScroller).use(pinia).mount("#app");
